// utils/waitForAuth.js
import { auth } from "../helper/firebaseClient";

export const waitForAuthReady = () =>
  new Promise(resolve => {
    const unsub = auth.onAuthStateChanged(user => {
      if (user) {
        resolve(user);
        unsub();
      }
    });
  });
